const GET_NOTIFY_MAIN = "notify/GET_NOTIFY_MAIN";
const GET_NOTIFY_MAIN_PARAM = "notify/GET_NOTIFY_MAIN_PARAM";
const GET_NOTIFY_LIST_PARAM = "notify/GET_NOTIFY_LIST_PARAM";

export const getNotifyMain = () => ({ type: GET_NOTIFY_MAIN });
export const getNotifyMainParam = (param) => ({
  type: GET_NOTIFY_MAIN_PARAM,
  param,
});
export const getNotifyListParam = (param) => ({
  type: GET_NOTIFY_LIST_PARAM,
  param,
});

const initialState = {
  notify: [
    {
      id_num:0,
      room_id: "",
      room_name: "",
      room_alert: 0
    },
  ],
  notify_list:[]
};

export default function funGetNotify(state = initialState, action) {
  switch (action.type) {
    case GET_NOTIFY_MAIN:
      return {
        ...state,
        notify: state.notify,
      };
    case GET_NOTIFY_MAIN_PARAM:
      return {
        ...state,
        notify: action.param,
      };

    case GET_NOTIFY_LIST_PARAM:
      return {
        ...state,
        notify_list: action.param,
      };

    default:
      return state;
  }
}
